/** Ultima azienda aperta: chi ha più aziende rientra lì (ADR 0118). */
const LAST_KEY = 'bk.ultimaAzienda';
export const rememberTenant = (id: string) => {
  try {
    localStorage.setItem(LAST_KEY, id);
  } catch {
    /* storage non disponibile */
  }
};
export const lastTenant = () => {
  try {
    return localStorage.getItem(LAST_KEY);
  } catch {
    return null;
  }
};
